import { FiCornerUpLeft, FiEye, FiGift, FiSend } from "react-icons/fi";
import spacetime from "spacetime";
import { BananaTypeLabel } from "./BananaTypeLabel";

interface Props {
  bananaOperations: Array<any>;
}

export const ViewBananaHistory = ({ bananaOperations }: Props) => {

  return (
    <section className="max-w-2xl mx-auto mt-12">
      <h3 className="text-xl font-semibold mb-6 text-center">Banana Travel History</h3>
      <ol className="relative">
        {bananaOperations.map((entry: any) => {

          const senderHandle =
            entry.sender?.username ? `@${entry.sender.username}` : "Bananonymous";
          const recipientHandle =
            entry.recipient?.username ? `@${entry.recipient.username}` : "Bananonymous";

          const who =
            ["create", "send", "sendBack"].includes(entry.type)
              ? (
                <>
                  by <span className="font-semibold">{entry.senderName
                    ? `${entry.senderName} (${senderHandle})`
                    : senderHandle}</span>
                </>
              )
              : (
                <>
                  by <span className="font-semibold">{recipientHandle}</span>
                </>
              );

          const where =
            entry.type === "open" ? (
              <>
                in <span className="font-medium">{entry.recipientLocation || "Bananaland"}</span>
              </>
            ) : (
              <>
                from <span className="font-medium">{entry.senderLocation || "Bananaland"}</span>
              </>
            );

          return (
            <li key={entry.id} className="mb-8">
              <div className="bg-white rounded-xl shadow p-4 sm:p-5">
                <div className="flex items-center justify-between gap-4">
                  <div className="flex items-center gap-2 text-sm">
                    <BananaTypeLabel type={entry.type} />
                  </div>
                  <time className="text-xs text-gray-500">
                    {spacetime(entry.createdAt).unixFmt("dd MMM YYYY HH:mm")}
                  </time>
                </div>
                
                <p className="mt-3 text-sm text-gray-700 leading-relaxed">
                  {who} {where}.
                  {entry.message && (
                    <>
                      {" "}
                      <span className="block mt-2 text-gray-600">
                        "{entry.message}"
                      </span>
                    </>
                  )}
                </p>
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  )
}